import { Injectable, inject } from '@angular/core';
import { ModifiedFieldService } from './modified-field.service';

@Injectable({
  providedIn: 'root'
})
export class FinaliseValueFieldService {
  private modifiedFieldService = inject(ModifiedFieldService);


  private finaliseValueFunctions: any = {};

  private ensureTemplateExist(templateId) {
    if (!this.finaliseValueFunctions[templateId]) {
      this.finaliseValueFunctions[templateId] = {};
    }
  }

  addFinaliseValueFunction(templateId, fieldName, func) {

    this.ensureTemplateExist(templateId);

    this.finaliseValueFunctions[templateId][fieldName] = func;
  }

  getFinaliseValueFunction(templateId, fieldName) {

    this.ensureTemplateExist(templateId);

    return this.finaliseValueFunctions[templateId][fieldName];
  }

  finaliseFieldValues(document, template) {

    if (document && this.modifiedFieldService.hasChanged(document.documentId)) {

      for (let t = 0, len = template.components.length; t < len; t++) {

        const fld = template.components[t];

        const finaliseFunc = this.getFinaliseValueFunction(template.documentId, fld.name);
        if (finaliseFunc) {
          finaliseFunc(document);
        }
      }
    }
  }
}
